import './lightSlider.css';
import 'lightslider';

(function($) {

/* set corusel slider for mobile */


let slider_width = $('#page.welcomeBonusJPN').length > 0 ||
                $('#page.30WelcomeBonusJPN').length > 0  ? 420 : 768;


    if(  $( window ).width() < slider_width){
        $('.carousel').addClass('slider-mob');
    }


    $('.lr-wrapper').children().addClass('slider-mob');



  $('.slider-mob').lightSlider({
    item: 2,
    loop: false,
    slideMove: 2,
    easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
    speed: 600,
    onSliderLoad: function () {
        $('.slider-mob').removeClass('cs-hidden');
    },
    responsive: [
        {
            breakpoint: 800,
            settings: {
                item: 4,
                slideMove: 2,
                slideMargin: 6,
            }
        },
        {
            breakpoint: 620,
            settings: {
                item: 3,
                slideMove: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                item: $('#oneSlide').length > 0 ? 1 :2 ,
                slideMove:  $('#oneSlide').length > 0 ? 1 :2
            }
        }
    ]
});



})(window.jQuery);